import { Dataset } from '../../types/types';
import { getDetailFilterObject } from './getDetailFilterObject';
import { getDetailItemsParamArray } from './getDetailItemsParamArray';
import { getItemsQueryString } from './getItemsQueryString';
import { getUrlParamsStringFromArray } from './getUrlParamsStringFromArray';
import { stringifyBracketParameter } from './stringifyBracketParameter';

export const getDetailParamsString = (dataset: Dataset, rowId: string) => {
  const urlParams: string[] = [];
  // Items param
  const items = getDetailItemsParamArray(dataset);
  const itemsQuery = getItemsQueryString(items);

  if (itemsQuery) {
    urlParams.push(itemsQuery);
  }
  // Filter param
  const filtersString = stringifyBracketParameter({
    filter: getDetailFilterObject(dataset, rowId),
  });

  if (filtersString) {
    urlParams.push(filtersString);
  }
  return getUrlParamsStringFromArray(urlParams);
};
